class ConnectorSelector extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.radioConnectorSelector = document.querySelector("#" + this.dataset.selector);
        this.radioConnectorContainer = document.querySelector('variant-mixed-inputs');
        this.popUpDialogConnectorGuide = document.querySelector("#" + this.dataset.connectorPopup);
        this.radioSelectedDisplay = document.querySelector("#" + this.dataset.radioSelectedDisplay);
        this.connectorSelectedDisplay = document.querySelector("#" + this.dataset.connectorSelectedDisplay);
        this.connectorImageContainerDisplay = document.querySelector("#n-cg-connector-image-container-display");
        this.radioModelSearchInput = document.querySelector("#n-cg-radio-model-search-input");

        this.radioConnectorContainer.addEventListener("change", this.onRadioConnectorChange.bind(this));
        this.radioModels = this.querySelectorAll('.n-cg-radio-model');
        this.noResults = document.querySelector("#n-cg-no-results");

        this.radioBrandContainers = this.querySelectorAll('.n-cg-radio-brand-container');
        this.onRadioModelClick = this.onRadioModelClick.bind(this);
        this.radioModels.forEach(this.applyListenersToRadioModels.bind(this));
        this.radioModelSearchInput.addEventListener("input", this.onRadioModelSearchInputChange.bind(this));
    }
    disconnectedCallback() {
        this.radioConnectorContainer.removeEventListener("change", this.onRadioConnectorChange.bind(this));
        this.radioModels.forEach(this.removeListenersFromRadioModels.bind(this));
        this.radioModelSearchInput.removeEventListener("input", this.onRadioModelSearchInputChange.bind(this));
    }
    onRadioConnectorChange() {
        this.radioSelectedDisplay.innerHTML = "No Radio Selected";
        this.connectorSelectedDisplay.innerHTML = this.radioConnectorSelector.value;
        this.changeConnectorImage(this.radioConnectorSelector.value);
    }
    applyListenersToRadioModels(radioModel) {
        radioModel.addEventListener('click', (event) => this.onRadioModelClick(event));
    }
    removeListenersFromRadioModels(radioModel) {
        radioModel.removeEventListener('click', (event) => this.onRadioModelClick(event));
    }
    changeConnectorImage(connector) {
        this.connectorImageContainerDisplay.querySelector(".n-cg-show").classList.remove("n-cg-show");
        this.connectorImageContainerDisplay.querySelector("div[data-connector='" + connector + "']").classList.add("n-cg-show");
    }
    onRadioModelClick(event) {
        this.radioConnectorSelector.value = event.target.dataset.radioConnector;
        this.radioConnectorContainer.dispatchEvent(new Event('change'));
        this.radioSelectedDisplay.innerHTML = "Radio: " + event.target.dataset.radioModel;
        this.connectorSelectedDisplay.innerHTML = event.target.dataset.radioConnector;
        this.changeConnectorImage(event.target.dataset.radioConnector);
        this.radioModelSearchInput.value = "";
        this.radioModelSearchInput.dispatchEvent(new Event('input'));
        this.popUpDialogConnectorGuide.close();
    }
    onRadioModelSearchInputChange(event) {
        this.radioBrandContainers.forEach(function(radioBrandContainer) {
            radioBrandContainer.style.display = "none";
        });
        let noResultsFound = true;
        this.radioModels.forEach(function(radioModel) {
            if (radioModel.dataset.radioModel.toLowerCase().includes(event.target.value.toLowerCase())) {
                radioModel.style.display = "block";
                document.querySelector(".n-cg-radio-brand-container[data-radio-brand='" + radioModel.dataset.radioBrand + "']").style.display = "block";
                noResultsFound = false;
            } else {
                radioModel.style.display = "none";
            }
        });
        if (noResultsFound) {
            this.noResults.style.display = "block";
        } else {
            this.noResults.style.display = "none";
        }
    }
}

customElements.define('connector-selector', ConnectorSelector);
// document.addEventListener('DOMContentLoaded', function() {
//     const radioConnectorSelector = document.querySelector("#Option-{{ unique_id }}-{{ forloop.index0 }}");
//     const radioConnectorContainer = document.querySelector('variant-mixed-inputs');
//     const popUpDialogConnectorGuide = document.querySelector('#product-popup-draw-{{ section_id }}-radio-connector-chart');
//     const radioSelectedDisplay = document.querySelector("#radio-selected-{{ unique_id }}");
//     const connectorSelectedDisplay = document.querySelector("#connector-selected-{{ unique_id }}");
    
//     radioConnectorContainer.addEventListener("change", function() {
//       radioSelectedDisplay.innerHTML = "Radio: None Selected";
//       connectorSelectedDisplay.innerHTML = "Connector: " + document.querySelector("#Option-{{ unique_id }}-{{ forloop.index0 }} input:checked, select").value;
//     });
//     const radioModels = document.querySelectorAll('.n-cg-radio-model');
//     radioModels.forEach(function(radioModel) {
//       radioModel.addEventListener('click', function() {
//         radioConnectorSelector.value = this.dataset.radioConnector;
//         radioConnectorContainer.dispatchEvent(new Event('change'));
//         radioSelectedDisplay.innerHTML = "Radio: " + this.dataset.radioModel;
//         connectorSelectedDisplay.innerHTML = "Connector: " + this.dataset.radioConnector;
//         popUpDialogConnectorGuide.close();
//       });
//     });
//   });